import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { fonts, brandColors } from '../../styles/variables';

const Wrapper = styled.div`
  ${({ primary, width, color }) => `
    width: 100%;
    max-width: ${width};
    color: ${color};
    font-family: ${primary ? fonts.athelas : fonts.monterrat};
    font-weight: ${primary ? 'normal' : 'bold'};
    font-size: ${primary ? '18px' : '22px'};
    font-style: ${primary ? 'italic' : 'normal'};
    letter-spacing: ${primary ? '1px' : 'normal'};
    line-height: ${primary ? '38px' : '36px'};
  `};
`;

class TextBlock extends React.PureComponent {
  render() {
    const { children, primary, width, color, className } = this.props;

    return (
      <Wrapper className={className} primary={primary} width={width} color={color}>
        {children}
      </Wrapper>
    );
  }
}

TextBlock.defaultProps = {
  primary: true,
  width: '300px',
  color: brandColors.blue,
  className: ''
};

TextBlock.propTypes = {
  children: PropTypes.node.isRequired,
  primary: PropTypes.bool,
  width: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string
};

export default connect()(TextBlock);



// WEBPACK FOOTER //
// ./src/components/TextBlock/index.jsx